import { render, staticRenderFns } from "./CompList.vue?vue&type=template&id=c1192e60&scoped=true"
import script from "./CompList.vue?vue&type=script&lang=js"
export * from "./CompList.vue?vue&type=script&lang=js"
import style0 from "./CompList.vue?vue&type=style&index=0&id=c1192e60&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1192e60",
  null
  
)

export default component.exports